<template>
  <div>
    <div class="page-title">New Blog Article</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="create"
      btnText="Add Blog Article"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.blog.page";
export default {
  components: { Form },
  metaInfo() {
    return {
      title: "New Blog Article",
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.BlogArticle.new();
      this.form = data;
    },
    async create() {
      await this.$api.BlogArticle.create(this.form);
      this.$router.push("/blog");
    },
  },
};
</script>

<style></style>
